/**
 * The save id of one change, for the Business Profile's and the Inbox's save and Undo hooks.
 *
 * The id is kept while the change is being sent: a retry after a network error or a timeout sends
 * the same id, so the server replays it rather than filing it twice. Once the server has filed it,
 * the hook calls `clear()` (its `onSuccess`), so the same change made again later (after his Undo,
 * which puts the list back on the answer the save was based on) is a new save, never a replay of
 * the first that files nothing while the card says "Saved." (BACKLOG
 * data-handling-held-from-reader: the vendor list and the products list kept their ids).
 */

import { useRef } from 'react';

export function useChangeId() {
  const pending = useRef<{ change: string; id: string } | null>(null);
  const idFor = (change: string): string => {
    if (pending.current?.change !== change) {
      pending.current = { change, id: crypto.randomUUID() };
    }
    return pending.current.id;
  };
  const clear = () => {
    pending.current = null;
  };
  return { idFor, clear };
}
